import { Typography, Grid } from "@mui/material";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../main/components/BaseButton";
import TextInput from "../../main/components/TextInput";
import { loginApi, usersApi } from "../../services/api";
import { MainContext } from "../../main/context/MainContextProvider";
import { PostLogin } from "../../services/api/routes/login";
import { useRopV2AppNative } from "../../modules/ropv2app/context/RopV2AppNativeContext";

const schema = yup.object().shape({
  password: yup.string().required("Necessário informar a senha"),
  confirmPassword: yup.string().required("Necessário confirmar a senha"),
});

export type RecoveryPasswordData = yup.InferType<typeof schema>;
export default function FirstAccess() {
  const { setUser, user } = useContext(MainContext);
  const { pushDeviceId } = useRopV2AppNative();

  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const onSubmit = async (data: RecoveryPasswordData) => {
    if (data.password !== data.confirmPassword) {
      setError("confirmPassword", {
        type: "manual",
        message: "As senhas não coincidem",
      });
      return;
    }
    try {
      if (!user?.email) {
        return;
      }
      setLoading(true);
      await usersApi.changePassword(data.password);

      const newUser: PostLogin = {
        userName: user?.email,
        password: data.password,
        pushDeviceId: pushDeviceId || undefined,
      };

      const userData = await loginApi.login(newUser);
      setUser(userData);
      navigate("/perfil");
    } catch (error) {
      navigate("erro");
    } finally {
      setLoading(false);
    }
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <Grid
      rowGap={2}
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(onSubmit)();
      }}
      justifyContent={"center"}
      alignItems={"center"}
      container
      maxWidth={"400px"}
    >
      <Grid item xs={10}>
        <Typography variant="h6">Nova Senha</Typography>
      </Grid>
      <Grid item mb={6} xs={10}>
        <Typography>Informe abaixo a sua nova senha:</Typography>
      </Grid>
      <Grid item xs={10}>
        <TextInput
          required
          label="Senha"
          fieldName="password"
          type="password"
          control={control}
          errors={errors}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={10}>
        <TextInput
          required
          label="Confirmar Senha"
          fieldName="confirmPassword"
          type="password"
          control={control}
          errors={errors}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={10}>
        <BaseButton
          type="submit"
          loading={loading}
          title="Enviar"
          endIcon={<ArrowForwardIcon />}
        />
      </Grid>
      <Grid xs={10} item justifyContent="center">
        <BaseButton
          type="button"
          onClick={() => {
            setUser(undefined);
            navigate("/login");
          }}
          title="Voltar para tela de login"
        />
      </Grid>
    </Grid>
  );
}
